const API_URL = process.env.REACT_APP_BACKEND_URL;

function detailMessage(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || JSON.stringify(item)).join(" ");
  if (detail.message) return detail.message;
  if (detail.error?.message) return detail.error.message;
  return String(detail);
}

function csrfToken() {
  if (typeof document === "undefined") return "";
  return document.cookie.split(";").map((part) => part.trim()).find((part) => part.startsWith("customer_csrf_token="))?.split("=").slice(1).join("=") || "";
}

async function request(path, options = {}) {
  const csrf = csrfToken();
  const response = await fetch(`${API_URL}/api${path}`, {
    credentials: "include",
    ...options,
    headers: { "Content-Type": "application/json", ...(csrf ? { "X-CSRF-Token": csrf } : {}), ...(options.headers || {}) },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(detailMessage(body.detail));
    error.status = response.status;
    throw error;
  }
  return body;
}

export function getCustomerMe() {
  return request("/customer-auth/me");
}

export function loginCustomer(email, password) {
  return request("/customer-auth/login", { method: "POST", body: JSON.stringify({ email, password }) });
}

export function acceptCustomerInvite(token, name, password) {
  return request("/customer-auth/accept-invite", { method: "POST", body: JSON.stringify({ token, name, password }) });
}

export function logoutCustomer() {
  return request("/customer-auth/logout", { method: "POST" });
}

export function getCustomerInvite(token) {
  return request(`/customer-auth/invite/${encodeURIComponent(token)}`);
}
